import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import leadsSearchFiltersI18nKeys from "app/pages/sales-intelligence/modules/leads-search-filters/utils/i18n";

import {
    StyledSiteTagsBulkDownloadBanner,
    StyledSiteTagsBulkDownloadBannerActions,
    StyledSiteTagsBulkDownloadBannerCopy,
    StyledSiteTagsBulkDownloadBannerDescription,
    StyledSiteTagsBulkDownloadBannerTitle,
} from "./styles";

type BulkDownloadBannerProps = {
    isLoading: boolean;
    onDownload: () => void;
};

const BulkDownloadBanner = ({ isLoading, onDownload }: BulkDownloadBannerProps): ReactElement => {
    const { translate } = useTranslate();

    return (
        <StyledSiteTagsBulkDownloadBanner data-automation="site-tags-bulk-download-banner">
            <StyledSiteTagsBulkDownloadBannerCopy>
                <StyledSiteTagsBulkDownloadBannerTitle>
                    {translate(leadsSearchFiltersI18nKeys.siteTagsBulkDownloadBannerTitle())}
                </StyledSiteTagsBulkDownloadBannerTitle>
                <StyledSiteTagsBulkDownloadBannerDescription>
                    <Text fontVariant="body2">
                        {translate(leadsSearchFiltersI18nKeys.siteTagsBulkDownloadBannerDescription())}
                    </Text>
                </StyledSiteTagsBulkDownloadBannerDescription>
            </StyledSiteTagsBulkDownloadBannerCopy>
            <StyledSiteTagsBulkDownloadBannerActions>
                <IconButton
                    type="outlined"
                    iconName="download"
                    onClick={onDownload}
                    isLoading={isLoading}
                    dataAutomation="site-tags-bulk-download-csv"
                >
                    {translate(leadsSearchFiltersI18nKeys.siteTagsBulkDownloadBannerLink())}
                </IconButton>
            </StyledSiteTagsBulkDownloadBannerActions>
        </StyledSiteTagsBulkDownloadBanner>
    );
};

export default BulkDownloadBanner;
